module.exports = "<div class=\"radio-list-control\" >\n        <div class=\"item ybicon\"\n             ng-click=\"$ctrl.selectItem(item)\"\n             ng-class=\"{'active':$ctrl.selected.value==item.value,\n                        'yb-select':$ctrl.selected.value==item.value}\"\n             ng-repeat=\"item in $ctrl.items\">{{item.text}}</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/radio-list/radio-list.html
// module id = 709
// module chunks = 3